import React, { FC, FormEvent, useRef, useState } from "react";
import { EMAIL_REGEX } from "../../utils";
import { ActionButton } from "../ActionButton";
import { CardContainer } from "../CardContainer";
import { MessageSvg } from "../MessageSvg";
import "./MessageForm.scss";

// const timeout = { enter: 250, exit: 250 };

export interface MessageFormData {
    readonly name: string;
    readonly email: string;
    readonly message: string;
}

export interface MessageFormProps {
    readonly title: string;
    onSubmit(data: MessageFormData): void;
}

const MessageForm: FC<MessageFormProps> = props => {
    const name = useRef<HTMLInputElement>(null);
    const email = useRef<HTMLInputElement>(null);
    const message = useRef<HTMLTextAreaElement>(null);
    const form = useRef<HTMLFormElement>(null);

    const [sent, setSent] = useState(false);

    function emailChanged() {
        if (email.current?.validity.patternMismatch) {
            email.current?.setCustomValidity("This doesn't look like an email!");
        } else {
            email.current?.setCustomValidity("");
        }
    }

    function send(event: FormEvent) {
        event.preventDefault();

        if (!form.current?.checkValidity()) {
            form.current?.reportValidity();
            return;
        }

        props.onSubmit({
            name: name.current?.value,
            email: email.current?.value,
            message: message.current?.value
        });

        setSent(true);

    }

    function sendAnother() {
        setSent(false);
    }

    function renderSent() {
        return (
            <div key="sent" className="message-form--sent">
                Your message has been sent. We will get back to you as soon as possible.
                <ActionButton
                    addClass="button-resend"
                    label="Send another"
                    onClick={sendAnother}
                />
            </div>
        );
    }

    function renderForm() {
        return (
            <form ref={form} key="not-sent" className="message-form" onSubmit={send}>
                <div className="content">
                    <div className="section">
                        <label className="label">Name</label>
                        <input ref={name} maxLength={255} />
                    </div>
                    <div className="section">
                        <label className="label">Email</label>
                        <input ref={email} onChange={emailChanged} type="email" required pattern={EMAIL_REGEX} />
                    </div>
                    <div className="section">
                        <label className="label">Message</label>
                        <textarea required ref={message} />
                    </div>
                </div>
                <div className="button-container">
                    <ActionButton
                        type="submit"
                        addClass="message-form__submit"
                        label="Send"
                    />
                </div>
            </form>
        );
    }

    return (
        <CardContainer title={props.title} addClass="offline-card" contentAddClass={sent ? "sent" : ""} icon={<MessageSvg />}>
            {/* <CSSTransition
                in={!sent}
                classNames={sent ? "message-form--shrink" : "message-form--grow"}
                timeout={timeout}
                > */}
                {sent ? renderSent() : renderForm()}
            {/* </CSSTransition> */}
        </CardContainer>
    );
};

export default MessageForm;